export default __webpack_public_path__ + "static/media/upload.3a71d01a.svg";